module.exports = __webpack_public_path__ + "static/media/logo.c6a6a06e.svg";